export default "__VITE_ASSET__at98hUNz__"